import { FC, useState } from 'react';
import { Card } from '../../../../components/card/card';
import { OfflineDepositSettings } from './offline-deposit-settings/offline-deposit-settings';
import { CardToCardSettings } from './card-to-card-settings/card-to-card-settings';
import './system-offline-deposit-settings.scss';

export const SystemOfflineDepositSettings: FC = () => {
    const [cardLoading, setCardLoading] = useState(false);
    return (
        <Card blur={cardLoading} className={'pmx-offline-deposit-settings'}>
            {/* <OfflineDepositSettings setCardLoading={setCardLoading} /> */}
            <CardToCardSettings setCardLoading={setCardLoading} />
        </Card>
    );
};
